module.exports = __webpack_public_path__ + "static/media/publishWitness.9c9db063.webp";